import { AccountingPackageDto } from '../revenue-items/dto/accounting-package.dto';

export class AdjustmentType {
  public AdjustmentTypeId: number;
  public AdjustmentType: string;
  public Descr: string;
  public GlAccountNum: string;
  public NormalBalance: string;
  public DebitAccount: string;
  public CreditAccount: string;
  public ReversingEntry: boolean;
  public AccountingPackageId: number;
  public AccountingPackage: AccountingPackageDto;

  public constructor() {
    this.AdjustmentTypeId = 0;
    this.AdjustmentType = '';
    this.Descr = '';
    this.GlAccountNum = '';
    this.NormalBalance = '';
    this.DebitAccount = '';
    this.CreditAccount = '';
  }
}
